import { render, staticRenderFns } from "./foodcourtStatisticsTable.vue?vue&type=template&id=fca46106&scoped=true&"
import script from "./foodcourtStatisticsTable.vue?vue&type=script&lang=js&"
export * from "./foodcourtStatisticsTable.vue?vue&type=script&lang=js&"
import style0 from "./foodcourtStatisticsTable.vue?vue&type=style&index=0&id=fca46106&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fca46106",
  null
  
)

export default component.exports